import * as Sentry from '@sentry/vue'
import {
  generateOtpExpiredData,
  objectToFormData,
  regexWaNumber,
} from '../utils'
import { removeBrokenPayload } from '../utils/api'
import router from '../routes'
import Analytics from '../services/analytics'

import Analysis from '../services/api/analysis'
import Auth from '../services/api/auth'
import Categories from '../services/api/categories'
import Content from '../services/api/content'
import Member from '../services/api/member'
import Country from '../services/api/country'
import Faq from '../services/api/faq'
import HomeAgregator from '../services/api/homeAggregator'
import Leads from '../services/api/leads'
import LiveTrade from '../services/api/liveTrade'
import Notification from '../services/api/notification'
import Promotion from '../services/api/promotion'
import PushNotification from '../services/api/pushNotif'
import Qa from '../services/api/qa'
import Stock from '../services/api/stock'
import Ticker from '../services/api/ticker'
import TradingView from '../services/api/tradingView'

/* #region  global action */
const setGSIError = (
  context,
  payload = {
    status: '',
    message: '',
    gsiToken: '',
  }
) => context.commit('SET_GSI_ERROR', payload)

const setNewNotif = (context, payload) => {
  context.commit('SET_NEW_NOTIF', payload)
}

const setLoginData = (context, payload = false) => {
  context.commit('LOGIN', payload)
}

const setRegisterSuccess = (context, payload = false) => {
  context.commit('SET_REGISTER_SUCCESS', payload)
}

/** 👇 modify open modal */
const setIsPremiumContent = (context, payload = false) => {
  context.commit('SET_IS_PREMIUM_CONTENT', payload)
}
const setEnableFeature = (context, payload) => {
  context.commit('SET_ENABLE_FEATURE', payload)
}
const setIsVipFeatures = (context, payload = false) => {
  context.commit('SET_IS_VIP_FEATURES', payload)
}
const setIsToManyLogin = (context, payload = false) => {
  context.commit('SET_IS_TO_MANY_LOGIN', payload)
}
const setIsOpenModalContactSupport = (context, payload = false) => {
  context.commit('SET_IS_OPEN_MODAL_CONTACT_SUPPORT', payload)
}
const setIsOpenModalSuccessChangePassword = (context, payload = false) => {
  context.commit('SET_IS_OPEN_MODAL_SUCCESS_CHANGE_PASSWORD', payload)
}
const setIsOpenModalVideoTutorial = (context, payload = false) => {
  context.commit('SET_IS_OPEN_MODAL_VIDEO_TUTORIAL', payload)
}
const setIsOpenModalShare = (context, payload = false) => {
  context.commit('SET_IS_OPEN_MODAL_SHARE', payload)
}
const setIsOpenModalRewardRiskRatioCalculation = (context, payload = false) => {
  context.commit('SET_IS_OPEN_MODAL_REWARD_RISK_RATIO_CALCULATION', payload)
}

const setPreviewImage = (context, payload = null) => {
  if (payload === null) {
    context.commit('SET_PREVIEW_IMAGE')
    return
  }

  context.commit('SET_PREVIEW_IMAGE', payload)
}

const setAppearedPromotions = (context, payload = []) => {
  context.commit('SET_APPEARED_PROMOTIONS', payload)
}

const setMaxQnaActiveChat = (context, payload = false) =>
  context.commit('SET_MAX_QNA_ACTIVE', payload)

const setHasOngoingQna = (context, payload = {}) =>
  context.commit('SET_HAS_ONGOING_QNA', payload)

const getNotifCount = async (context) => {
  try {
    const res = await Notification.getNotificationCountApi()

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_NOTIF_COUNT', res.data.Count)
  } catch (error) {
    context.commit('SET_ERROR', error)
  }
}

const fetchNotifCategory = async (context) => {
  try {
    const res = await Notification.getNotificationCategoryApi()
    if (res) {
      context.commit('SET_NOTIF_CATEGORY', res.data)
    }
  } catch (error) {
    context.commit('SET_ERROR', error)
  }
}

const postReadAllNotification = async (context) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Notification.postReadAllNotificationApi()
    if (res) {
      context.commit('SET_LOADING', false)
      window.location.reload()
    }
  } catch (error) {
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const postReadNotification = async (context, payload) => {
  try {
    const res = await Notification.postReadNotificationApi(payload.id)
    if (res) {
      context.commit('SET_READ_NOTIFICATION', payload.id)
      if (payload.landing_url) {
        window.location.href = payload.landing_url
      }
    }
  } catch (error) {
    context.commit('SET_ERROR', error)
  }
}

const setIsOpenTermCondition = (context, payload = false) => {
  context.commit('SET_IS_OPEN_TERM_CONDITION', payload)
}
const setIsOpenDisclaimer = (context, payload = false) => {
  context.commit('SET_IS_OPEN_DISCLAIMER', payload)
}
const setLoading = (context, payload) => {
  context.commit('SET_LOADING', payload)
}
const setEnableStepperGuide = (context, payload = false) => {
  context.commit('SET_ENABLE_STEPPER_GUIDE', payload)
}

const setSpinnerLoading = (context, payload, timer = 3000) => {
  context.commit('SET_SPINNER_LOADING', payload)
  if (payload) {
    setTimeout(() => context.commit('SET_SPINNER_LOADING', false), timer)
  }
}

const setOtpRecord = (context, payload) => {
  context.commit('SET_OTP_RECORD', payload)
}

const setPageHistory = (context, payload) => {
  context.commit('SET_PAGE_HISTORY', payload)
}

const resetInputRecord = (context, payload) => {
  context.commit('RESET_INPUT_RECORD')
}

const resetDialCode = (context, payload) => {
  context.commit('SET_DIAL_CODE')
}

const clearFilter = (context, payload) => {
  context.commit('CLEAR_FILTER')
}

const clearStockDetails = (context, payload) => {
  context.commit('SET_STOCK_DETAILS', {})
}

const setInputRecord = (context, payload) => {
  context.commit('SET_INPUT_RECORD', payload)
}

const setQnaRecord = (context, payload) => {
  context.commit('SET_QNA_RECORD', payload)
}

const setVerifyUserAccount = (context, payload = {}) => {
  context.commit('SET_VERIFY_USER_ACCOUNT', payload)
}

const setFingerprint = (context, payload) =>
  context.commit('SET_FINGERPRINT', payload)

const setUserAgent = (context, payload) =>
  context.commit('SET_USER_AGENT', payload)

const setCategory = (context, payload) => {
  context.commit('SET_CATEGORY', payload)
}

const setFilter = (context, payload) => {
  try {
    context.commit('SET_FILTER', payload)
  } catch (error) {
    Sentry.captureMessage('setFilter')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const setSearch = (context, payload) => {
  try {
    context.commit('SET_SEARCH', payload)
  } catch (error) {
    Sentry.captureMessage('setSearch')
    context.commit('SET_ERROR', error)
  }
}

const openSearch = (context, payload) => {
  try {
    context.commit('OPEN_SEARCH', payload)
  } catch (error) {
    Sentry.captureMessage('openSearch')
    context.commit('SET_ERROR', error)
  }
}

const setScrollYPos = (context, payload) => {
  try {
    context.commit('SET_Y_POS', payload)
  } catch (error) {
    Sentry.captureMessage('setScrollYPos')
    context.commit('SET_ERROR', error)
  }
}

const getMemberDetails = async (context) => {
  try {
    const fetchDetails = await Auth.memberDetails()
    const fetchshipStatus = await Auth.membershipStatus()
    const fetchSubscription = await Auth.memberSubscription()

    const resultMemberDetails = fetchDetails?.data ?? null
    const resultMembershipStatus = fetchshipStatus?.data ?? null
    const resultMemberSubscription = fetchSubscription?.data ?? null

    if (
      [
        resultMemberDetails,
        resultMembershipStatus,
        resultMemberSubscription,
      ].includes(null)
    ) {
      throw 'Server Error'
    }

    context.commit('SET_MEMBER_DETAILS', resultMemberDetails ?? {})
    context.commit('SET_MEMBERSHIP_STATUS', resultMembershipStatus ?? {})
    context.commit('SET_SUBSCRIPTION', resultMemberSubscription ?? [])
    return fetchDetails
  } catch (error) {
    Sentry.captureMessage('getMemberDetails')
    return error.response
  }
}

const checkMemberFeature = async (context, payload) => {
  try {
    const result = await Auth.memberFeature(payload)
    return result?.data?.is_available ?? false
  } catch (error) {
    Sentry.captureMessage('checkMemberFeature')
    return false
  }
}
/* #endregion */

/* #region  auth */
const login = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const origin = new URL(window.location.href).searchParams.get('from')

    const res = await Auth.loginApi(payload)
    if (res) {
      await context.commit('LOGIN', res.data)
      context.commit('SET_LOADING', false)

      /** 👇 [ANALYTIC] */
      Analytics.LoginRegister.LoginSuccess({ loginMethod: 'email' })

      router.push({ name: 'dashboard', query: { from: origin } })
    }
  } catch (error) {
    Sentry.captureMessage('login')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const loginFromAcademy = async (context, payload) => {
  try {
    const res = {
      data: {
        id: payload.id,
        name: payload.name,
        email: payload.email,
      },
      token: payload.token,
    }

    context.commit('SET_LOADING', true)

    await context.commit('LOGIN', res)
    context.commit('SET_LOADING', false)

    router.push({ name: 'dashboard' })
  } catch (error) {
    /** 👇 [ANALYTIC] */
    // analytics.logEvent('login_failed', {
    //   login_method: 'Email',
    //   email: payload.username,
    // })
    Sentry.captureMessage('login')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const gsiLogin = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const origin = new URL(window.location.href).searchParams.get('from')
    const res = await Auth.gsiLoginApi(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    await context.commit('LOGIN', res.data)
    context.commit('SET_LOADING', false)

    /** 👇 [ANALYTIC] */
    Analytics.LoginRegister.LoginSuccess({ loginMethod: 'google' })

    router.push({ name: 'dashboard', query: { from: origin } })
  } catch (error) {
    Sentry.captureMessage('login')
    context.commit('SET_LOADING', false)

    if (error?.response?.status >= 401 && error?.response?.status != 429) {
      await context.commit('SET_GSI_ERROR', {
        status: error.response.status,
        message: error.response.data.message,
        gsiToken: payload.google_token,
      })

      // check if user currently on login page and unregister
      if (router.history.current.name === 'login') {
        router.push({
          name: 'signup',
          query: { from: 'login' },
        })
      }
      return
    }

    context.commit(
      'SET_ERROR',
      error?.response?.data?.message || 'Server Error'
    )
  }
}

const loginPhoneNumber = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const origin = new URL(window.location.href).searchParams.get('from')

    const res = await Auth.loginPhone(payload)
    if (typeof res?.data !== 'object') throw 'Server Error'

    await context.commit('LOGIN', res.data)
    context.commit('SET_LOADING', false)

    /** 👇 [ANALYTIC] */
    Analytics.LoginRegister.LoginSuccess({ loginMethod: 'whatsapp' })

    router.push({ name: 'dashboard', query: { from: origin } })

    return res
  } catch (error) {
    Sentry.captureMessage('loginPhoneNumber')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)

    return error.response
  }
}

const gsiRegister = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Auth.gsiRegisterApi(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    // context.commit('SET_REGISTER_SUCCESS', true)
    context.commit('SET_INPUT_RECORD', { login: res.data })
    context.commit('SET_GSI_ERROR', {
      status: '',
      message: '',
      gsiToken: '',
    })

    /** 👇 [ANALYTIC] */
    // window.ga('send', {
    //   hitType: 'event',
    //   eventCategory: 'login and signup',
    //   eventAction: 'login - click daftar dengan google',
    //   eventLabel: `users`,
    // })
    // analytics.logEvent('click_daftarGoogleRegisterLogin', `users`)

    context.commit('SET_LOADING', false)

    return res
  } catch (error) {
    /** 👇 [ANALYTIC] */
    // analytics.logEvent('login_failed', {
    //   login_method: 'Email',
    //   email: payload.username,
    // })

    Sentry.captureMessage('gsiRegister')
    context.commit('SET_GSI_ERROR', {
      status: error.response.status,
      message: error.response.data.message,
      gsiToken: payload.google_token,
    })
    context.commit('SET_LOADING', false)

    if (error.response.status !== 429) {
      context.commit('SET_ERROR', error.response.data.message)
    }

    return error.response
  }
}

const gsiErrorReset = async (context, payload) => {
  context.commit('SET_GSI_ERROR', {
    status: payload.status,
    message: payload.message,
    gsiToken: payload.gsiToken,
  })
}

const logout = async (context) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Auth.logoutApi({
      params: {
        device: 'web',
      },
    })

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('LOGOUT')
    window.open('/', '_self')
  } catch (error) {
    context.commit('LOGOUT')
    window.open('/', '_self')
  }
}

const getRefreshToken = async (context, payload) => {
  try {
    if (payload.refresh_token === undefined) return false

    context.commit('SET_LOADING', true)
    const res = await Auth.refreshTokenApi(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_REFRESH_TOKEN', res.data)

    return true
  } catch (error) {
    context.commit('LOGOUT')
    return false
  }
}

const forceLogout = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    context.commit('LOGOUT')
    context.commit('SET_LOADING', false)
    window.open('/', '_self')
  } catch (error) {
    Sentry.captureMessage('forceLogout')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const changePassword = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Auth.updatePassword(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    Sentry.captureMessage('changePassword')
    context.commit('SET_LOADING', false)

    return { status: 401 }
  }
}

// generateOtpExpiredData
const requestOTPRegister = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Auth.sendOTPRegister(payload)

    const countdown = 60
    const { newExpired } = generateOtpExpiredData(countdown)

    context.commit('SET_OTP_RECORD', {
      ...res.data,
      countdown,
      interval: null,
      phone: payload,
      expired: newExpired,
    })
    context.commit('SET_LOADING', false)

    return res?.status
  } catch (error) {
    const countdown = error.response?.data?.remaining_second || 60
    const { newExpired, isToManyRequestOtp } = generateOtpExpiredData(countdown)

    Sentry.captureMessage('requestOTPRegister')
    // context.commit('SET_ERROR', error.response?.data?.message)
    context.commit('SET_LOADING', false)
    context.commit('SET_OTP_RECORD', {
      ...error?.response?.data,
      countdown: countdown,
      interval: null,
      phone: payload,
      expired: newExpired,
    })

    if (isToManyRequestOtp) {
      router.replace({ query: { toManyRequestOtp: true } })
    }

    return error?.response?.status
  }
}

const requestVerification = async (context, payload) => {
  try {
    if (Number(payload.phone)) {
      context.commit('SET_LOADING', true)

      await Auth.phoneVerification(payload)

      context.commit('SET_RESEND_OTP_REMAINING', 60)
      context.commit('SET_LOADING', false)

      window.open('/login?type=verifyphone', '_self')
      return
    }

    context.commit('SET_ERROR', 'Format nomor belum sesuai')
  } catch (error) {
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)

    if (error?.response?.data?.message?.length) return

    if (error?.response?.data?.remaining_second) {
      return context.commit(
        'SET_RESEND_OTP_REMAINING',
        error?.response?.data?.remaining_second
      )
    }

    if (error?.response?.data?.remaining_second <= 60) {
      return window.open('/login?type=verifyphone', '_self')
    }
  }
}

const decrementResendOTPRemaining = async (context, payload) => {
  context.commit('SET_RESEND_OTP_REMAINING', payload)
}

const registerUser = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Auth.register(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_REGISTER_SUCCESS', true)
    context.commit('SET_INPUT_RECORD', { login: res.data })
    context.commit('SET_LOADING', false)

    return res
  } catch (error) {
    Sentry.captureMessage('registerUser')
    context.commit('SET_REGISTER_SUCCESS', false)
    context.commit('SET_LOADING', false)

    if (error.response.status !== 429) {
      context.commit('SET_ERROR', error.response.data.message)
    }

    return error.response
  }
}

const sendRequestResetPassword = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Auth.requestResetPassword(payload)

    context.commit('SET_FORGOT_SUCCESS_DIALOG', true)
    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    if (error?.response?.status === 429) {
      error.response.status = 500
    }

    Sentry.captureMessage('sendRequestResetPassword')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const sendLeads = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const ressponse = await Leads.postLeads(payload)

    if (typeof ressponse?.data !== 'object') throw 'Server Error'

    // 📱 --- [SENDLEADS:Processing] Menangani newline untuk WhatsApp dengan proper encoding
    if (ressponse.data?.whatsapp_text) {
      const memberStatus = context.state.membershipData?.status?.toLowerCase()
      const isRegular = memberStatus === 'regular'

      const { premium_contact_number, regular_contact_number } =
        context.state.firebaseRemoteConfig

      // Decode URL encoded newline dan ganti dengan newline yang proper untuk WhatsApp
      const pretext = ressponse.data.whatsapp_text
        .replaceAll('%0a', '.\n') // Ganti %0a dengan \n
        .replaceAll('%0A', '.\n') // Handle uppercase juga
        .replaceAll('\\n', '.\n') // Handle double escaped newline

      ressponse.data.whatsapp_text = pretext
      ressponse.data.sales_phone = isRegular
        ? regular_contact_number._value
        : premium_contact_number._value

      console.log('===> sendLeads', {
        premium_contact_number,
        regular_contact_number,
        data: ressponse.data,
      })
    }

    context.commit('SET_LOADING', false)
    return ressponse
  } catch (error) {
    Sentry.captureMessage('sendLeads')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const getChartConfig = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await TradingView.chartConfig(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_CHART_CONFIG', res.data)
    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    Sentry.captureMessage('getChartConfig')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const dismissForgotSuccessDialog = async (context, payload = false) => {
  context.commit('SET_FORGOT_SUCCESS_DIALOG', payload)
}

const checkResetPasswordCode = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Auth.getResetPasswordCodeStatus(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    Sentry.captureMessage('checkResetPasswordCode')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const sendResetPassword = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Auth.verifyResetPassword(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    const messageData = {
      ...res,
      data: { ...res.data, message: 'Success' },
    }

    context.commit('SET_LOADING', false)
    context.commit('SET_SUCCESS', messageData)

    return res
  } catch (error) {
    Sentry.captureMessage('sendResetPassword')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}
/* #endregion */

const verifyUserAccount = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Auth.checkAccount(payload)

    context.commit('SET_VERIFY_USER_ACCOUNT')
    context.commit('SET_LOADING', false)

    return res?.status
  } catch (error) {
    Sentry.captureMessage('verifyUserAccount')
    context.commit('SET_LOADING', false)

    if (error?.response?.status !== 400) {
      context.commit('SET_ERROR', error)
      return error?.response
    }
    if (typeof error?.response?.data?.message !== 'string')
      return error?.response

    context.commit('SET_VERIFY_USER_ACCOUNT', {
      existingEmail: error?.response?.data?.message.includes('email'),
      existingWhatsapp: error?.response?.data?.message.includes('phone'),
    })
  }
}

const verifyUser = async (context, payload) => {
  try {
    if (regexWaNumber(payload.phone)) {
      context.commit('SET_LOADING', true)

      await Auth.verify(payload)

      context.commit('SET_LOADING', false)
      return context.commit('SET_REGISTER_SUCCESS', true)
    }

    throw 'Invalid verification code'
  } catch (error) {
    Sentry.captureMessage('verifyUser')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)

    // mock here
    context.commit('SET_REGISTER_SUCCESS', false)
  }
}

const resendOTPRegisterUser = async (context, payload) => {
  try {
    if (regexWaNumber(payload)) {
      context.commit('SET_LOADING', true)
      await Auth.resendOTPRegister(payload)
      context.commit('SET_LOADING', false)
    }

    throw 'Invalid WA Number'
  } catch (error) {
    Sentry.captureMessage('resendOTPRegisterUser')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

/* #region  Live Trading */
const fetchLiveTradeData = async (context, payload) => {
  try {
    const category = payload.params.category
    const strategy =
      typeof payload.params.filter === 'string'
        ? payload.params?.filter?.replaceAll(',', '|')
        : ''

    const params = {
      page: payload.params?.page ?? 1,
      size: payload.params?.page_size ?? payload.params?.size ?? 10,
      // sort: 'created_at desc',
      // endDate: payload.params.endDate,
      // offset: payload.params.offset,
      // profitBy: payload.params.profitBy,
      // startDate: payload.params.startDate,
      // content_format: payload.params.category,
      query: {
        search: payload.params?.search ?? '',
        period: payload.params?.period ?? '',
        categories: payload.params?.categories ?? '',
        strategy,
      },
    }

    context.commit('SET_LOADING', true)

    let res = await LiveTrade.getLiveTrades(category, params)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIVE_TRADE_DATA', res.data.data)
    context.commit('SET_PAGINATION', res.data)
    context.commit('SET_LOADING', false)
  } catch (error) {
    context.commit('SET_LIVE_TRADE_DATA', [])
    Sentry.captureMessage('fetchLiveTradeData')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const addLiveTrade = (context, payload) => {
  try {
    context.commit('ADD_LIVE_TRADE', payload)
  } catch (error) {
    Sentry.captureMessage('addLiveTrade')
    context.commit('SET_ERROR', error)
  }
}

const clearLiveTrade = (context) => {
  context.commit('CLEAR_LIVE_TRADE')
}

const fetchLiveTradeDetail = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    let res = await LiveTrade.getLiveTradeDetails(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIVE_TRADE_DETAIL', res.data)
    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    context.commit('SET_LOADING', false)
    Sentry.captureMessage('fetchLiveTradeDetail')
    context.commit('SET_ERROR', error)
    return error.response
  }
}
/* #endregion */

/* #region  Stock */
const fetchBuyStockData = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Stock.fetchBuyStock(payload)
    if (res?.data) {
      context.commit('SET_BUY_STOCK', res.data)
      context.commit('SET_LOADING', false)
      router.push({
        name: 'buy',
        params: { id: payload.emi_id, status: true },
      })
    }
  } catch (error) {
    Sentry.captureMessage('fetchBuyStockData')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const buyStock = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Stock.postBuyStock(payload)
    if (res?.data) {
      context.commit('SET_BUY_STOCK', res.data)
      context.commit('SET_LOADING', false)
      router.push({ name: 'successbuy' })
    }
  } catch (error) {
    Sentry.captureMessage('buyStock')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchSellStockData = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Stock.fetchSellStock(payload)
    if (res?.data) {
      context.commit('SET_SELL_STOCK', res.data)
      context.commit('SET_LOADING', false)
      router.push({
        name: 'sell',
        params: { id: payload.emi_id, status: true },
      })
    }
  } catch (error) {
    Sentry.captureMessage('fetchSellStockData')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const sellStock = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Stock.postSellStock(payload)
    if (res?.data) {
      context.commit('SET_SELL_STOCK', res.data)
      context.commit('SET_LOADING', false)
      router.push({ name: 'successsell' })
    }
  } catch (error) {
    Sentry.captureMessage('sellStock')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchListStocks = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Stock.getListStocks(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    res.data.params = payload

    context.commit('SET_LIST_STOCK', res.data)
    context.commit('SET_PAGINATION', res.data)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchListStocks')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const resetListStocks = (context) => {
  try {
    context.commit('SET_LOADING', true)
    context.commit('RESET_LIST_STOCK')
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('resetListStocks')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchLastPrice = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Stock.getLastPrice(payload)

    if (res?.data) {
      context.commit('SET_LAST_PRICE', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchLastPrice')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchChartStock = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Stock.getChartStock(payload)
    if (res?.data) {
      context.commit('SET_CHART_STOCK', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchChartStock')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchAnalysisStock = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Stock.getAnalystStock(payload)
    if (res?.data) {
      context.commit('SET_ANALYSIS_STOCK', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    context.commit('SET_ANALYSIS_STOCK', { data: {} })
    Sentry.captureMessage('fetchAnalysisStock')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

/* #endregion */

/* #region  Push Notification */
const postPushNotif = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    let res = {}
    if (context.state.membership.is_vip) {
      res = await PushNotification.updatePushNotif(payload)
    } else {
      res = await PushNotification.updatePushNotifFree(payload)
    }
    if (res?.data) {
      context.commit('SET_PUSH_NOTIF', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('postPushNotif')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchPushNotif = async (context) => {
  try {
    let res = {}
    if (context.state.membership.is_vip) {
      res = await PushNotification.getPushNotif()
    } else {
      res = await PushNotification.getPushNotifFree()
    }

    if (res?.data) {
      context.commit('SET_PUSH_NOTIF', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchPushNotif')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}
/* #endregion */

/* #region  firebase */
const setFirebaseToken = (context, payload) => {
  context.commit('SET_FIREBASE_TOKEN', payload)
}

const registerFirebaseTokenAfterLogin = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    await Auth.firebaseTokenRegisterApi(payload)

    console.log('===> [Notifications] push messaging already connected')
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('registerFirebaseTokenAfterLogin')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const setFirebaseRemoteConfig = async (context, payload) => {
  context.commit('SET_FIREBASE_REMOTE_CONFIG', payload)
}

/* #endregion */

/* #region  Sahamku */
const fetchDetailStock = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Stock.getDetailStocksCode(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_STOCK_DETAILS', res.data)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchDetailStock')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}
/* #endregion */

/* #region Notification  */
const fetchNotification = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Notification.getNotification(payload)
    if (res?.data) {
      context.commit('SET_LIST_NOTIFICATION', res.data)
      context.commit('SET_PAGINATION', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchNotification')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const clearNotification = (context) => {
  context.commit('CLEAR_LIST_NOTIFICATION')
}
/* #endregion */

/* #region Analysis  */
const fetchAnalysis = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Analysis.getAnalysis(payload)

    if (res?.data) {
      context.commit('SET_LIST_ANALYST', res.data)
      context.commit('SET_PAGINATION', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchAnalysis')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchAnalysisDetail = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const result = await Analysis.getAnalysisDetail(payload)

    if (typeof result?.data !== 'object') throw 'Server Error'

    result.data.is_enable_access = true

    context.commit('SET_ANALYST', result.data)
    context.commit('SET_LOADING', false)
    return result
  } catch (error) {
    if (error.status === 403) {
      if (error.response?.data) {
        error.response.data.is_enable_access = false
        context.commit('SET_ANALYST', error.response.data)
        context.commit('SET_LOADING', false)
      }
      return error
    }

    Sentry.captureMessage('fetchAnalysisDetail')
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const fetchAnalysisChild = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    let res = await Content.getContentDetail(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIST_CONTENT_CHILD', res.data)
    // context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchAnalysisChild')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const clearAnalysis = (context) => {
  context.commit('CLEAR_LIST_ANALYST')
}

/* #endregion */

/* #region Member  */
const fetchProgram = async (context) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Member.getProgram()

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIST_PROGRAM', res.data)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchProgram')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}
const fetchProgramDetail = async (context, payload) => {
  try {
    const res = await Member.getProgramDetail(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    return res.data
  } catch (error) {
    Sentry.captureMessage('fetchProgramDetail')
    return null
  }
}
const updatePopupDisclaimerStatus = async (context, payload) => {
  try {
    await Member.updatePopupDisclaimerStatus()
    return true
  } catch (error) {
    return false
  }
}

/* #endregion */

/* #region Content  */
const fetchContent = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    let res = {}
    res = await Content.getContents(payload)
    if (res?.data) {
      context.commit('SET_LIST_CONTENT', res.data)
      context.commit('SET_PAGINATION', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchContent')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchOneContent = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const result = await Content.getContentDetail(payload)

    if (typeof result?.data !== 'object') throw 'Server Error'

    result.data.is_enable_access = true

    context.commit('SET_CONTENT', result.data)
    context.commit('SET_LOADING', false)
    return result
  } catch (error) {
    if (error.status === 403) {
      if (error.response?.data) {
        error.response.data.is_enable_access = false
        context.commit('SET_CONTENT', error.response.data)
        context.commit('SET_LOADING', false)
      }
      return error
    } else {
      context.commit('SET_CONTENT', { data: {} })
      Sentry.captureMessage('fetchOneContent')
      context.commit('SET_ERROR', error)
      context.commit('SET_LOADING', false)
    }

    return error
  }
}

const clearContent = (context) => {
  context.commit('CLEAR_LIST_CONTENT')
}

const fetchContentChild = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    let res = {}
    res = await Content.getContentDetail(payload)

    if (res?.data) {
      context.commit('SET_LIST_CONTENT_CHILD', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchContentChild')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchTicker = async (context) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Ticker.getTicker()

    if (res?.data) {
      context.commit('SET_LIST_TICKER', res.data.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchTicker')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchCountryDialCode = async (context, payload) => {
  try {
    /** 👇 reset dial code data */
    context.commit('SET_DIAL_CODE')

    context.commit('SET_LOADING', true)

    const res = await Country.getCountryDialCode(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_DIAL_CODE', res.data.dialCodes)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchCountryDialCode')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchEventHighlights = async (context) => {
  try {
    context.commit('SET_LOADING', true)

    // move from /banner to /home-aggregator-v3
    const res = await HomeAgregator.getEventHighlights()

    if (res?.data) {
      context.commit('SET_LIST_EVENT', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('getEventHighlights')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}
const fetchEducationHome = async (context) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Content.getEducationHome()

    if (res?.data) {
      context.commit('SET_EDUCATION_HOME', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchEducationHome')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchBanner = async (context) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await HomeAgregator.getPromotionBanner()

    if (res && res.data) {
      context.commit('SET_LIST_PROMOTION_BANNER', res.data.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchBanner')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchAnalysisHome = async (context) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Content.getAnalysisHome()

    if (res?.data) {
      context.commit('SET_ANALYST_HOME', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchAnalysisHome')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}
const fetchFaqHome = async (context) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Content.getFaqHome()

    if (res?.data) {
      context.commit('SET_FAQ_HOME', res)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchFaqHome')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchPromotion = async (context) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Promotion.getPromotion()

    if (res?.data) {
      context.commit('SET_PROMOTION_POPUP', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchPromotion')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchPromotionDetail = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Promotion.getPromotionDetail(payload)

    if (res?.data) {
      context.commit('SET_PROMOTION_DETAIL', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    context.commit('SET_PROMOTION_DETAIL', {})
    Sentry.captureMessage('fetchPromotionDetail')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}
/* #endregion */

/* #region FAQ  */
const fetchFaq = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const payloadData = removeBrokenPayload(payload.params)

    const res = await Faq.getFaqs(payloadData)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIST_FAQ', res.data)
    context.commit('SET_PAGINATION', res.data)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchFaq')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchFaqDetails = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Faq.getFaqDetails(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_FAQ', res.data)
    context.commit('SET_LOADING', false)

    return res
  } catch (error) {
    Sentry.captureMessage('fetchFaqDetails')
    // context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)

    return error.response
  }
}

const fetchFaqRelated = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Faq.getFaqRelated(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIST_FAQ_RELATED', res.data.data)
    context.commit('SET_LOADING', false)

    return res
  } catch (error) {
    Sentry.captureMessage('fetchFaqRelated')
    context.commit('SET_LOADING', false)

    return error.response
  }
}

const fetchOneFaq = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    let res = {}
    if (context.state.membership.is_vip) {
      res = await Faq.getFaq(payload)
    } else {
      res = await Faq.getFaqFree(payload)
    }

    if (res?.data) {
      context.commit('SET_FAQ', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchOneFaq')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchFaqFrequent = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Faq.getFaqFrequent(payload)
    if (res?.data) {
      context.commit('SET_FAQ_FREQUENT', res.data)
      context.commit('SET_PAGINATION', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchFaqFrequent')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchFaqLast = async (context) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Faq.getFaqLast()
    if (res?.data) {
      context.commit('SET_FAQ_LAST', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('fetchFaqLast')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const clearFaq = (context) => {
  context.commit('CLEAR_LIST_FAQ')
}

const clearFaqFrequent = (context) => {
  context.commit('CLEAR_LIST_FAQ_FREQUENT')
}
/* #endregion */

/* #region Chat  */
const endConversation = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Qa.closeConversation(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LOADING', false)
    context.commit('SET_SUCCESS', res)

    return res
  } catch (error) {
    Sentry.captureMessage('endConversation')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const fetchConversation = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Qa.getConversation(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_QNA_RECORD', { conversation: res?.data })
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchConversation')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchChat = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.getChats(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_QNA_RECORD', { chat: res?.data })

    if (payload?.params?.page === 1) {
      context.commit('CLEAR_LIST_CHAT')
    }

    context.commit('SET_LIST_CHAT', res.data)

    context.commit('SET_PAGINATION', res.data)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchChat')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const postChat = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const formData = objectToFormData(payload)
    const res = await Qa.replyChat(formData)

    context.commit('SET_SUCCESS', res)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('postChat')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const postChatMedia = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const formData = objectToFormData(payload)
    const res = await Qa.replyChat(formData)

    context.commit('SET_SUCCESS', res)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('postChatMedia')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const addChatRating = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.postChatRating(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('addChatRating')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const addFaqRating = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Faq.postFaqRating(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('addFaqRating')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const checkChatRating = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.getChatRating(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_QNA_RECORD', { rating: { ...res.data } })
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('checkChatRating')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const addChat = (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    context.commit('ADD_LIST_CHAT', payload)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('addChat')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const clearChat = (context) => {
  context.commit('CLEAR_LIST_CHAT')
}

const fetchStatusQa = async (context) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Qa.getStatusQa()
    if (res?.data) {
      context.commit('SET_STATUS_QA', res.data)
      context.commit('SET_LOADING', false)
    }
    return res
  } catch (error) {
    Sentry.captureMessage('fetchStatusQa')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const checkAnswer = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Qa.autoAnswer(payload)
    if (res?.data) {
      context.commit('SET_AUTO_ANSWER', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('checkAnswer')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const clearAutoAnswer = (context) => {
  try {
    context.commit('SET_LOADING', true)
    context.commit('SET_AUTO_ANSWER', { data: {} })
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('clearAutoAnswer')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchListQuestion = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.getQaList(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIST_QUESTION', res.data)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchListQuestion')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const clearListQuestion = (context) => {
  try {
    context.commit('SET_LOADING', true)
    context.commit('CLEAR_LIST_QUESTION')
  } catch (error) {
    Sentry.captureMessage('clearListQuestion')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}
/* #endregion */

/* #region  App Version */
// const setAppVersion = (context, payload) => {
//   try {
//     context.commit('SET_LOADING', true)
//     context.commit('SET_APP_VERSION', payload)
//     context.commit('SET_LOADING', false)
//   } catch (error) {
//     Sentry.captureMessage('setAppVersion')
//     context.commit('SET_ERROR', error)
//     context.commit('SET_LOADING', false)
//   }
// }
/* #endregion */

const clearListBelanja = (context) => {
  context.commit('CLEAR_LIST_BELANJA')
}
/* #endregion */

const clearListLangganan = (context) => {
  context.commit('CLEAR_LIST_LANGGANAN')
}
/* #endregion */

/* #region  categories */
const fetchCategories = async (context, payload) => {
  try {
    const res = await Categories.getCategories(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIST_CATEGORIES', res.data)
  } catch (error) {
    Sentry.captureMessage('fetchCategories')
    context.commit('SET_ERROR', error)
  }
}
const fetchQnaCategories = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Categories.getCategories(payload)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIST_CATEGORIES_QNA', res.data)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('fetchQnaCategories')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}
/* #endregion */

/* #region  ticket */
const fetchTiket = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.getQaList(payload.params)

    if (typeof res?.data !== 'object') throw 'Server Error'

    context.commit('SET_LIST_TIKET', res.data)
    context.commit('SET_PAGINATION', res.data)
    context.commit('SET_LOADING', false)
    return res?.data?.data
  } catch (error) {
    Sentry.captureMessage('fetchTiket')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return []
  }
}

const postTiket = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const formData = objectToFormData(payload)
    const res = await Qa.postOtherQuestion(formData)

    if (typeof res?.data !== 'object') throw 'Server Error'

    // context.commit('ADD_TIKET', res.data)
    context.commit('SET_LOADING', false)

    return res
  } catch (error) {
    Sentry.captureMessage('postTiket')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)

    return error.response
  }
}

const checkTiketAutoAnswer = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Qa.checkAutoAnswerV2(payload)
    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    Sentry.captureMessage('checkTiketAutoAnswer')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error
  }
}

const postTiketAutoAnswer = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Qa.autoAnswerV2(payload)
    if (res?.data) {
      context.commit('ADD_TIKET', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    Sentry.captureMessage('postTiketAutoAnswer')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const clearListTiket = (context) => {
  context.commit('CLEAR_LIST_TIKET')
}

const clearListTiketDetail = (context) => {
  context.commit('CLEAR_LIST_TIKET_DETAIL')
}

const getQAPortofolio = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.getPortfolio(payload)

    context.commit('SET_LOADING', false)

    context.commit('SET_PORTFOLIO_QA', res.data)
  } catch (error) {
    context.commit('SET_PORTFOLIO_QA')
    Sentry.captureMessage('getQAPortofolio')
    context.commit('SET_LOADING', false)
  }
}

const addQAPortfolio = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.addPortfolio(payload)

    context.commit('SET_LOADING', false)

    return res
  } catch (error) {
    Sentry.captureMessage('addQAPortfolio')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const editQAPortfolio = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const dataPost = [payload].map(({ id, ...item }) => item)
    const data = dataPost[0]
    const res = await Qa.editPortfolio({ id: payload.id, data })

    context.commit('SET_LOADING', false)

    return res
  } catch (error) {
    Sentry.captureMessage('editQAPortfolio')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const addQAPortfolioDetails = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const data = {
      portofolio_id: payload.id,
      stock: payload.code,
      lot: payload.lot,
      buy_price: payload.buy_price,
    }

    const res = await Qa.addPortfolioDetail(data)

    context.commit('SET_LOADING', false)

    return res
  } catch (error) {
    Sentry.captureMessage('addQAPortfolioDetails')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)

    return error.response
  }
}

const editQAPortfolioDetails = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const data = {
      portofolio_id: payload.portofolio_id,
      stock: payload.stock,
      lot: payload.lot,
      buy_price: payload.buy_price,
    }
    const res = await Qa.editPortfolioDetail({ id: payload.id, data })

    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    Sentry.captureMessage('editQAPortfolioDetails')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const deleteQAPortfolioDetails = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    await Qa.deletePortfolioDetail(payload)

    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('deleteQAPortfolioDetails')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const addQA = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.addQAPortfolioTicket(payload)

    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    Sentry.captureMessage('addQA')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const addQATanyaSaham = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.postQATanyaSaham(payload)

    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    Sentry.captureMessage('addQATanyaSaham')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
    return error.response
  }
}

const deleteQA = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)

    const res = await Qa.deleteQATicket(payload)
    if (typeof res?.data !== 'object') throw 'Server error'

    context.commit('REMOVE_LIST_TIKET', payload)
    context.commit('SET_LOADING', false)
  } catch (error) {
    Sentry.captureMessage('deleteQA')
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchForYou = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await HomeAgregator.getHomeForYou()

    if (res?.data) {
      context.commit('SET_FOR_YOU', res.data)
      context.commit('SET_LOADING', false)
    }
  } catch (error) {
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const fetchLandingpage = async (context, payload) => {
  try {
    context.commit('SET_LOADING', true)
    const res = await Content.getLandingpage(payload)

    if (typeof res !== 'object') throw 'Server error'

    context.commit('SET_LANDINGPAGE', res)
    context.commit('SET_LOADING', false)
  } catch (error) {
    context.commit('SET_ERROR', error)
    context.commit('SET_LOADING', false)
  }
}

const checkQARequestPermission = async (context, payload) => {
  context.commit('SET_HAS_ONGOING_QNA')
  context.commit('SET_MAX_QNA_ACTIVE', false)

  try {
    context.commit('SET_LOADING', true)
    const res = await Qa.getTanyaSahamCheck()
    context.commit('SET_LOADING', false)
    return res
  } catch (error) {
    const hasOngoingQna = error?.response?.data?.message
      ?.toLowerCase()
      .includes('sampai pertanyaan anda dijawab')
    const maxQnaActive = error?.response?.data?.message
      ?.toLowerCase()
      .includes('anda sudah memiliki 3 active chat')

    if (hasOngoingQna) {
      const message = error?.response?.data?.message
      error.response.status = 401
      const data = { status: true, message }
      context.commit('SET_HAS_ONGOING_QNA', data)
    }

    if (maxQnaActive) {
      context.commit('SET_MAX_QNA_ACTIVE', true)
    }

    context.commit('SET_LOADING', false)
    return error.response
  }
}

const setError = (context, payload = '') => context.commit('SET_ERROR', payload)

const setSuccess = (context, payload = '') => {
  context.commit('SET_SUCCESS', {
    status: 200,
    data: {
      message: payload,
    },
  })
}

const resetError = async (context, payload) => {
  context.commit('RESET_ERROR', payload)
}

const otpTimeDelay = async (context, payload) => {
  const otp = context.getters.getInputRecord.otp
  let countdown = otp?.countdown
  const interval = setInterval(() => {
    if (countdown > 0) {
      countdown--
      context.commit('SET_OTP_RECORD', { countdown })
      return
    }

    clearInterval(interval)
  }, 1000)
}

const closePopupBanner = async (context, payload) => {
  context.commit('SET_IS_CLOSE_POPUP_BANNER', payload)
}

/* #endregion */

export default {
  setFingerprint,
  setUserAgent,
  setIsOpenTermCondition,
  setIsOpenDisclaimer,
  login,
  loginFromAcademy,
  gsiLogin,
  gsiRegister,
  gsiErrorReset,
  logout,
  forceLogout,
  fetchLiveTradeData,
  setNewNotif,
  getNotifCount,
  postReadAllNotification,
  postReadNotification,
  fetchNotifCategory,
  addLiveTrade,
  clearLiveTrade,
  fetchBuyStockData,
  fetchSellStockData,
  buyStock,
  setFirebaseToken,
  registerFirebaseTokenAfterLogin,
  setFirebaseRemoteConfig,
  sellStock,
  fetchListStocks,
  postPushNotif,
  fetchPushNotif,
  setCategory,
  fetchDetailStock,
  clearStockDetails,
  fetchNotification,
  clearNotification,
  fetchProgram,
  fetchProgramDetail,
  updatePopupDisclaimerStatus,
  fetchContent,
  clearContent,
  fetchOneContent,
  fetchFaq,
  fetchOneFaq,
  fetchFaqDetails,
  fetchFaqRelated,
  clearFaq,
  fetchChat,
  postChat,
  addChatRating,
  addFaqRating,
  checkChatRating,
  addChat,
  clearChat,
  // setAppVersion,
  changePassword,
  clearListBelanja,
  fetchCategories,
  fetchQnaCategories,
  fetchFaqFrequent,
  fetchFaqLast,
  clearFaqFrequent,
  fetchContentChild,
  clearListLangganan,
  fetchTiket,
  postTiket,
  clearListTiket,
  clearListTiketDetail,
  setLoading,
  setEnableStepperGuide,
  setSpinnerLoading,
  fetchTicker,
  fetchEventHighlights,
  fetchAnalysisStock,
  resetListStocks,
  fetchLiveTradeDetail,
  fetchStatusQa,
  deleteQA,
  fetchAnalysis,
  fetchAnalysisDetail,
  clearAnalysis,
  fetchAnalysisChild,
  fetchEducationHome,
  fetchAnalysisHome,
  fetchFaqHome,
  fetchLastPrice,
  setFilter,
  clearFilter,
  setSearch,
  openSearch,
  setScrollYPos,
  postChatMedia,
  requestVerification,
  loginPhoneNumber,
  checkAnswer,
  getMemberDetails,
  checkMemberFeature,
  clearAutoAnswer,
  fetchListQuestion,
  postTiketAutoAnswer,
  fetchChartStock,
  checkTiketAutoAnswer,
  registerUser,
  verifyUser,
  resendOTPRegisterUser,
  clearListQuestion,
  fetchPromotion,
  fetchPromotionDetail,
  fetchForYou,
  fetchLandingpage,
  getRefreshToken,
  resetInputRecord,
  setInputRecord,
  setOtpRecord,
  verifyUserAccount,
  setVerifyUserAccount,
  setGSIError,
  fetchBanner,
  checkQARequestPermission,
  setMaxQnaActiveChat,
  requestOTPRegister,
  setRegisterSuccess,
  setLoginData,
  getQAPortofolio,
  addQAPortfolio,
  editQAPortfolio,
  addQAPortfolioDetails,
  editQAPortfolioDetails,
  deleteQAPortfolioDetails,
  addQA,
  setHasOngoingQna,
  sendRequestResetPassword,
  sendResetPassword,
  checkResetPasswordCode,
  setQnaRecord,
  fetchConversation,
  endConversation,
  dismissForgotSuccessDialog,
  otpTimeDelay,
  addQATanyaSaham,
  setSuccess,
  setError,
  resetError,
  decrementResendOTPRemaining,
  closePopupBanner,
  setIsPremiumContent,
  setEnableFeature,
  setIsVipFeatures,
  setIsToManyLogin,
  setPreviewImage,
  setAppearedPromotions,
  getChartConfig,
  sendLeads,
  setPageHistory,
  fetchCountryDialCode,
  resetDialCode,
  setIsOpenModalContactSupport,
  setIsOpenModalVideoTutorial,
  setIsOpenModalShare,
  setIsOpenModalRewardRiskRatioCalculation,
  setIsOpenModalSuccessChangePassword,
}
